import { render } from "./SlideBarNavigation.vue?vue&type=template&id=159b0d72&scoped=true"
import script from "./SlideBarNavigation.vue?vue&type=script&lang=js"
export * from "./SlideBarNavigation.vue?vue&type=script&lang=js"

import "./SlideBarNavigation.vue?vue&type=style&index=0&id=159b0d72&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-159b0d72"

export default script